import { Stack } from "@certa/catalyst/layouts/Stack";
import { Button, ButtonTypes } from "@certa/catalyst/components/Button";
import { TextInput } from "@certa/catalyst/components/Inputs";
import { Plus as PlusIcon } from "@certa/icons/components/Plus";
import { Minus as MinusIcon } from "@certa/icons/components/Minus";
import { FieldStatus } from "@certa/catalyst/components/types";
import { useScalingText, useScalingTool } from "./ScalingTool.hooks";
import { MAX_SCALE, MIN_SCALE } from "./ScalingTool.constants";

type ScalingToolProps = {
  initialScale: number | null;
  setScale: (scale: number) => void;
};

export const ScalingTool = (props: ScalingToolProps) => {
  const {
    currentScale,
    handleInputChange,
    decreaseScale,
    increaseScale,
    hasError
  } = useScalingTool(props);
  const {
    scalePercentageText,
    decreaseScaleText,
    increaseScaleText,
    scaleMinMaxErrorText
  } = useScalingText();

  return (
    <Stack direction="horizontal" align="center" gap="16">
      <Button
        type={ButtonTypes.ICON}
        onClick={decreaseScale}
        disabled={currentScale <= MIN_SCALE}
        aria-label={decreaseScaleText}
      >
        <MinusIcon />
      </Button>
      <TextInput
        width="4.5rem"
        label={scalePercentageText}
        value={`${currentScale}%`}
        onChange={handleInputChange}
        aria-label={scalePercentageText}
        allowClear={false}
        status={hasError ? FieldStatus.ERROR : undefined}
        error={hasError ? scaleMinMaxErrorText : ""}
      />
      <Button
        type={ButtonTypes.ICON}
        onClick={increaseScale}
        disabled={currentScale >= MAX_SCALE}
        aria-label={increaseScaleText}
      >
        <PlusIcon />
      </Button>
    </Stack>
  );
};
